import api from './api';

export interface TourProgress {
  tourDefinitionId?: number;
  tourName: string;
  tourTitle?: string;
  stepNumber: number;
  isCompleted: boolean;
  lastCompletedAt: string | null;
}

export interface UpdateTourProgressRequest {
  tourDefinitionId?: number;
  tourName?: string;
  stepNumber: number;
  isCompleted: boolean;
}

export const tourService = {
  // دریافت وضعیت همه تورها برای کاربر فعلی
  getAllTourProgress: async (): Promise<TourProgress[]> => {
    const response = await api.get('/tour/progress');
    return response.data;
  },

  // دریافت وضعیت یک تور خاص (by ID - جدید)
  getTourProgressById: async (tourDefinitionId: number): Promise<TourProgress> => {
    const response = await api.get(`/tour/progress/by-id/${tourDefinitionId}`);
    return response.data;
  },

  // دریافت وضعیت یک تور خاص (by name - Legacy)
  getTourProgress: async (tourName: string): Promise<TourProgress> => {
    const response = await api.get(`/tour/progress/${tourName}`);
    return response.data;
  },

  // به‌روزرسانی وضعیت تور (supports both tourDefinitionId and tourName)
  updateTourProgress: async (request: UpdateTourProgressRequest): Promise<TourProgress> => {
    const response = await api.post('/tour/progress', request);
    return response.data;
  },

  // ریست کردن تور (by ID - جدید)
  resetTourProgressById: async (tourDefinitionId: number): Promise<void> => {
    await api.delete(`/tour/progress/by-id/${tourDefinitionId}`);
  },

  // ریست کردن تور (by name - Legacy)
  resetTourProgress: async (tourName: string): Promise<void> => {
    await api.delete(`/tour/progress/${tourName}`);
  },
};
